export default __webpack_public_path__ + "static/media/cycle.3a22862a.jpg";